import { EVALUATION_TYPES } from "../../../../../components/dashboard/hse/evaluation/evaluationUtils";
import { EvaluationListPage } from "../../../../../components/dashboard/hse/evaluation/EvaluationListPage";

export const HseKsManagementReviewList = () => (
  <EvaluationListPage evaluationType={EVALUATION_TYPES.MANAGEMENT_REVIEW} />
);
